import { useEffect } from 'react';

const EDITABLE_SELECTOR = 'input, textarea, select, [contenteditable]:not([contenteditable="false"])';

// Captures before component handlers so their stopPropagation() can't hide the key, then decides after
// dispatch so a handler that consumed Escape via preventDefault() keeps focus where it put it.
export const blurEditableOnEscape = (event: KeyboardEvent): void => {
    const { target } = event;

    if (
        event.key !== 'Escape' ||
        event.isComposing ||
        !(target instanceof HTMLElement) ||
        target.getAttribute('aria-expanded') === 'true' ||
        !target.matches(EDITABLE_SELECTOR)
    ) {
        return;
    }

    setTimeout(() => {
        if (!event.defaultPrevented && document.activeElement === target) {
            target.blur();
        }
    });
};

export const useEscapeToBlur = (enabled: boolean): void => {
    useEffect(() => {
        if (!enabled) {
            return;
        }

        window.addEventListener('keydown', blurEditableOnEscape, { capture: true });

        return () => {
            window.removeEventListener('keydown', blurEditableOnEscape, { capture: true });
        };
    }, [enabled]);
};
